import { useTranslation } from 'react-i18next'
import { useMediaQuery, useTheme } from '@mui/material'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts'

import { RenderActiveDot } from './active-dot.component'
import { GraphTickXAxis } from './graph-tick-x-axis.component'
import { GraphTickYAxis } from './graph-tick-y-axis.component'
import { IDashboardGraphData } from 'src/types'

import { FONTS } from 'src/constants'

interface IGraphProps {
  data: IDashboardGraphData[]
  label?: string
}

const xAxis = 'timeframe'
const yAxis = 'views'

const Graph = ({ data, label }: IGraphProps) => {
  const [t] = useTranslation()
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  if (!label) {
    label = t('products-views-views-column.v')
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data} margin={{ top: 40, right: 30, left: -17.5, bottom: 40 }}>
        <XAxis dataKey={xAxis} tick={(props) => <GraphTickXAxis {...props} />} />
        <CartesianGrid vertical={false} stroke={theme.palette.custom.grey} />
        <YAxis
          label={{
            value: isLaptop ? '' : label,
            position: 'top',
            dy: -20,
            dx: 35,
            textAnchor: 'middle',
            style: {
              fontSize: FONTS.SIZES.xl,
              fontWeight: FONTS.WEIGHTS.bold,
              fontFamily: FONTS.FAMILIES.notoSans,
              fill: theme.palette.custom.darkBlue2,
            },
          }}
          dataKey={yAxis}
          axisLine={{ stroke: 'none' }}
          tickLine={{ stroke: 'none' }}
          tick={(props) => <GraphTickYAxis {...props} />}
        />
        <Tooltip
          content={() => null}
          cursor={false}
          allowEscapeViewBox={{ x: true, y: true }}
          wrapperStyle={{ visibility: 'hidden' }}
          isAnimationActive={false}
        />
        <Line
          type="monotone"
          dataKey="views"
          stroke={theme.palette.custom.primary}
          strokeWidth={3}
          activeDot={<RenderActiveDot />}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
export { Graph }
